import { FC, useMemo } from 'react';
import { hasRole } from '../../utils/roles';
import { useAppSelector } from '../../store';
import { selectIdentity } from '../../store/entities/identity';
import { TourniquetCaption } from './TourniquetCaption';
import { useTranslation } from 'react-i18next';
import { UserRole } from '@api/models/enums/UserRole';

export interface TourniquetTitleProps {
  style?: React.CSSProperties;
}

export const TourniquetTitle: FC<TourniquetTitleProps> = ({ style }) => {
  const identity = useAppSelector(selectIdentity);
  const { t } = useTranslation();

  const title = useMemo(() => {
    if (hasRole(identity.roles, [UserRole.Training])) return 'tourniquet.titleTraining';
    if (hasRole(identity.roles, [UserRole.TourniquetTraining])) return 'tourniquet.titleTourniquetTraining';
    if (hasRole(identity.roles, [UserRole.Tourniquet])) return 'tourniquet.titleTourniquet';
    return '';
  }, [identity.roles]);

  return <TourniquetCaption title={t(`${title}`)} style={style} />;
};
